"use client";

import { Button } from "@ui/components/core/Button";
import Spinner20 from "@ui/icons/20x20/spinner-20.svg";

export interface SubmitButtonProps {
  canSubmit: boolean;
  isSubmitting: boolean;
  submitLabel: string;
  submittingLabel: string;
  submitError: string | null;
}

/**
 * Shared submit button + inline error block used by all HubSpot-bound forms.
 */
export function SubmitButton({
  canSubmit,
  isSubmitting,
  submitLabel,
  submittingLabel,
  submitError,
}: SubmitButtonProps) {
  return (
    <>
      {submitError && (
        <div className='tw-text-sm tw-mb-4 text-negative' role='alert'>
          {submitError}
        </div>
      )}
      <Button
        type='submit'
        variant='primary'
        size='lg'
        className='tw-w-full tw-mt-4'
        disabled={!canSubmit || isSubmitting}
      >
        {isSubmitting ? (
          <span className='tw-flex tw-items-center tw-justify-center tw-gap-2'>
            <Spinner20 className='tw-animate-spin' />
            {submittingLabel}
          </span>
        ) : (
          submitLabel
        )}
      </Button>
    </>
  );
}
